import React, { useState, useEffect, useRef, useCallback } from 'react';
import { supabase } from './supabase';

// BYR-1234-ABCD
const formatTakipKodu = (val) => {
  const temiz = val.replace(/[^A-Z0-9]/gi, '').toUpperCase().slice(0, 11);
  let r = temiz.slice(0, 3);
  if (temiz.length > 3) r += '-' + temiz.slice(3, 7);
  if (temiz.length > 7) r += '-' + temiz.slice(7, 11);
  return r;
};

function Teslimat() {
  const [kodInput, setKodInput]           = useState('');
  const [toast, setToast]                 = useState(null);
  const [sonTeslimler, setSonTeslimler]   = useState([]);
  const [islemYapiliyor, setIslemYapiliyor] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    sonTeslimleriGetir();
    setTimeout(() => inputRef.current?.focus(), 100);
  }, []);

  const sonTeslimleriGetir = async () => {
    const { data } = await supabase
      .from('depo')
      .select('*, musteriler(ad)')
      .eq('durum', 'Teslim Edildi')
      .order('teslim_tarihi', { ascending: false })
      .limit(10);
    if (data) setSonTeslimler(data);
  };

  const toastGoster = useCallback((mesaj, tip) => {
    setToast({ mesaj, tip });
    setTimeout(() => setToast(null), 3000);
  }, []);

  // ── Takip koduna göre teslimat (kargo bazlı) ───────────────────
  const teslimEt = useCallback(async (kod) => {
    if (!kod || islemYapiliyor) return;
    setIslemYapiliyor(true);

    const temizKod = kod.trim().toUpperCase();

    // 1) depo tablosunda takip_kodu ara
    const { data: depoArr } = await supabase
      .from('depo')
      .select('id, urun, musteri_id, sefer_id, kod_gecerli, musteriler(ad)')
      .eq('takip_kodu', temizKod)
      .limit(1);

    if (!depoArr || depoArr.length === 0) {
      toastGoster('✗ Geçersiz takip kodu.', 'hata');
      setIslemYapiliyor(false);
      return;
    }

    const kayit = depoArr[0];

    // 2) Kod geçerli mi?
    if (!kayit.kod_gecerli) {
      toastGoster('⚠ Bu kargo zaten teslim edilmiştir.', 'uyari');
      setIslemYapiliyor(false);
      return;
    }

    // 3) Teslim et + kodu geçersiz yap
    await supabase
      .from('depo')
      .update({ durum: 'Teslim Edildi', teslim_tarihi: new Date().toISOString(), kod_gecerli: false })
      .eq('id', kayit.id);

    // 4) Sefer tüm malları teslim mi?
    if (kayit.sefer_id) {
      const { data: kalanlar } = await supabase
        .from('depo')
        .select('id, durum')
        .eq('sefer_id', kayit.sefer_id)
        .neq('id', kayit.id)
        .neq('durum', 'Teslim Edildi');

      if (!kalanlar || kalanlar.length === 0) {
        await supabase
          .from('seferler')
          .update({ durum: 'Teslim Edildi' })
          .eq('id', kayit.sefer_id);
      }
    }

    toastGoster(`✓ ${kayit.musteriler?.ad || 'Müşteri'} — ${kayit.urun} teslim edildi.`, 'basarili');
    sonTeslimleriGetir();
    setIslemYapiliyor(false);
  }, [islemYapiliyor, toastGoster]);

  const gonder = async () => {
    const kod = kodInput.trim();
    setKodInput('');
    await teslimEt(kod);
    setTimeout(() => inputRef.current?.focus(), 50);
  };

  // ── Toast stilleri ─────────────────────────────────────────────
  const toastStil = {
    basarili: { background: '#14532d', border: '1px solid #4ade80', color: '#bbf7d0' },
    hata:     { background: '#7f1d1d', border: '1px solid #f87171', color: '#fecaca' },
    uyari:    { background: '#78350f', border: '1px solid #fbbf24', color: '#fde68a' },
  };

  const tarihFormat = (t) => {
    if (!t) return '—';
    const d = new Date(t);
    return d.toLocaleDateString('tr-TR') + ' ' + d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div style={{
      flex: 1,
      minHeight: '100vh',
      background: '#0a0f1e',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Arial, sans-serif',
      color: '#fff',
    }}>

      {/* ── Toast ── */}
      {toast && (
        <div style={{
          position: 'fixed', top: '16px', left: '50%', transform: 'translateX(-50%)',
          ...toastStil[toast.tip],
          padding: '14px 28px', borderRadius: '12px',
          fontSize: '16px', fontWeight: '700', zIndex: 9999,
          boxShadow: '0 8px 30px rgba(0,0,0,0.6)',
          maxWidth: '90vw', textAlign: 'center',
        }}>
          {toast.mesaj}
        </div>
      )}

      {/* ── Başlık ── */}
      <div style={{ padding: '20px 20px 0', textAlign: 'center' }}>
        <div style={{ fontSize: '11px', color: '#4a6fa5', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '4px' }}>
          BYR SWORD
        </div>
        <div style={{ fontSize: '22px', fontWeight: '800', color: '#fff' }}>Teslimat Takibi</div>
      </div>

      {/* ── İçerik ── */}
      <div style={{ flex: 1, padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

        {/* Takip kodu girişi */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div style={{ fontSize: '13px', color: '#4a6fa5', marginBottom: '2px' }}>
            🔑 Müşteri Takip Kodu
          </div>
          <input
            ref={inputRef}
            value={kodInput}
            onChange={e => setKodInput(formatTakipKodu(e.target.value))}
            onKeyDown={e => { if (e.key === 'Enter') gonder(); }}
            placeholder="BYR-1234-ABCD"
            autoFocus
            style={{
              width: '100%', padding: '18px 20px',
              fontSize: '20px', fontWeight: '600', letterSpacing: '0.1em',
              border: '2px solid #1e3a5f', borderRadius: '14px',
              background: '#131929', color: '#fff', boxSizing: 'border-box',
              outline: 'none', fontFamily: 'monospace',
            }}
            onFocus={e => { e.target.style.borderColor = '#3b82f6'; }}
            onBlur={e => { e.target.style.borderColor = '#1e3a5f'; }}
          />
          <button
            onClick={gonder}
            disabled={islemYapiliyor}
            style={{
              width: '100%', padding: '16px',
              background: islemYapiliyor ? '#1a3a1a' : '#166534',
              color: islemYapiliyor ? '#4a6fa5' : '#fff',
              border: 'none', borderRadius: '12px',
              fontSize: '16px', fontWeight: '700',
              cursor: islemYapiliyor ? 'default' : 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {islemYapiliyor ? 'İşleniyor...' : 'Teslim Et →'}
          </button>
          <div style={{ textAlign: 'center', fontSize: '12px', color: '#4a6fa5' }}>
            Kodu girin ve Enter'a basın ya da butona tıklayın
          </div>
        </div>

        {/* ── Son Teslimler ── */}
        {sonTeslimler.length > 0 && (
          <div>
            <div style={{
              fontSize: '10px', color: '#4a6fa5', textTransform: 'uppercase',
              letterSpacing: '0.12em', marginBottom: '10px',
            }}>
              Son Teslimler
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {sonTeslimler.map((m) => (
                <div key={m.id} style={{
                  background: '#131929', borderRadius: '10px',
                  padding: '10px 14px', display: 'flex',
                  justifyContent: 'space-between', alignItems: 'center',
                  border: '1px solid #1e3a5f',
                }}>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: '#e2e8f0' }}>{m.urun}</div>
                    <div style={{ fontSize: '11px', color: '#4a6fa5', marginTop: '2px' }}>
                      {m.musteriler?.ad || '—'}
                    </div>
                  </div>
                  <div style={{ fontSize: '10px', color: '#2d5a8e', textAlign: 'right', flexShrink: 0, marginLeft: '10px' }}>
                    {tarihFormat(m.teslim_tarihi)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Teslimat;
